import React from 'react';
import './Amenities.css';

const Amenities = () => {
  const amenities = [
    { icon: '❄️', title: 'Air Conditioning', description: 'All rooms equipped with AC for your comfort' },
    { icon: '📺', title: 'Television', description: 'TV in every room for entertainment' },
    { icon: '📶', title: 'Free WiFi', description: 'High-speed internet connectivity' },
    { icon: '🔌', title: 'Power Inverter', description: 'Uninterrupted power backup facility' },
    { icon: '🚿', title: 'Hot & Cold Water', description: '24/7 hot and cold water supply' },
    { icon: '🧼', title: 'Toiletries Provided', description: 'Essential toiletries included' },
    { icon: '✨', title: 'Clean Toilets', description: 'Well-maintained modern bathrooms' },
    { icon: '📍', title: 'Great Location', description: 'Convenient location in Ujjain' },
    { icon: '👥', title: 'Group Hall', description: 'Large hall for 12-person gatherings' }
  ];

  return (
    <section id="amenities" className="amenities section">
      <div className="container">
        <h2 className="section-title">Amenities & Services</h2>
        <p className="section-subtitle">Everything You Need for a Perfect Stay</p>
        
        <div className="amenities-grid">
          {amenities.map((amenity, index) => (
            <div key={index} className="amenity-card">
              <div className="amenity-icon">{amenity.icon}</div>
              <h3>{amenity.title}</h3>
              <p>{amenity.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Amenities;

